module.exports = "<div class=\"tel-input\">\n  <input #input (input)=\"inputEvent($event)\" type=\"tel\" [textMask]=\"{mask: mask, showMask: true}\" (click)=\"$event.target.select()\"/>\n  <ng-select #select\n    [(ngModel)]=\"selected\"\n    [options]=\"countries\"\n    (selected)=\"selectedEvent($event)\">\n    <ng-template\n      #optionTemplate\n      let-option=\"option\">\n      <div class=\"flag\" [ngClass]=\"'f_'+option?.value\"></div>\n      <span class=\"country\">{{option?.label}}</span>\n    </ng-template>\n  </ng-select>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/tel-input/tel-input.component.html
// module id = uPdn
// module chunks = 6